var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
!function (e, o) {
  "object" == typeof exports && "object" == typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define("openstack-uicore-foundation", [], o) : "object" == typeof exports ? exports["openstack-uicore-foundation"] = o() : e["openstack-uicore-foundation"] = o();
}(this, function () {
  return function () {
    "use strict";

    var e = {
        5097: function _(e, o, t) {
          t.d(o, {
            SET_LOGGED_USER: function SET_LOGGED_USER() {
              return n;
            }
          });
          t(1116), t(6842), t(9087), t(9558), t(1742);
          var n = "SET_LOGGED_USER";
        },
        3195: function _(e, o, t) {
          t.d(o, {
            AUTH_ERROR_ACCESS_TOKEN_EXPIRED: function AUTH_ERROR_ACCESS_TOKEN_EXPIRED() {
              return i;
            },
            AUTH_ERROR_ID_TOKEN_INVALID: function AUTH_ERROR_ID_TOKEN_INVALID() {
              return s;
            },
            AUTH_ERROR_LOCK_ACQUIRE_ERROR: function AUTH_ERROR_LOCK_ACQUIRE_ERROR() {
              return a;
            },
            AUTH_ERROR_MISSING_AUTH_INFO: function AUTH_ERROR_MISSING_AUTH_INFO() {
              return n;
            },
            AUTH_ERROR_MISSING_NONCE_PARAM: function AUTH_ERROR_MISSING_NONCE_PARAM() {
              return _;
            },
            AUTH_ERROR_MISSING_OTP_PARAM: function AUTH_ERROR_MISSING_OTP_PARAM() {
              return l;
            },
            AUTH_ERROR_MISSING_PKCE_PARAM: function AUTH_ERROR_MISSING_PKCE_PARAM() {
              return u;
            },
            AUTH_ERROR_MISSING_REFRESH_TOKEN: function AUTH_ERROR_MISSING_REFRESH_TOKEN() {
              return r;
            },
            AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR: function AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR() {
              return c;
            }
          });
          var n = "AUTH_ERROR_MISSING_AUTH_INFO",
            r = "AUTH_ERROR_MISSING_REFRESH_TOKEN",
            i = "AUTH_ERROR_ACCESS_TOKEN_EXPIRED",
            a = "AUTH_ERROR_LOCK_ACQUIRE_ERROR",
            c = "AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR",
            s = "AUTH_ERROR_ID_TOKEN_INVALID",
            l = "AUTH_ERROR_MISSING_OTP_PARAM",
            u = "AUTH_ERROR_MISSING_PKCE_PARAM",
            _ = "AUTH_ERROR_MISSING_NONCE_PARAM";
        },
        1742: function _(e, o, t) {
          t.r(o), t.d(o, {
            ACCESS_TOKEN_SKEW_TIME: function ACCESS_TOKEN_SKEW_TIME() {
              return m;
            },
            RESPONSE_TYPE_CODE: function RESPONSE_TYPE_CODE() {
              return P;
            },
            RESPONSE_TYPE_IMPLICIT: function RESPONSE_TYPE_IMPLICIT() {
              return N;
            },
            clearAccessToken: function clearAccessToken() {
              return B;
            },
            clearAuthInfo: function clearAuthInfo() {
              return W;
            },
            doLogin: function doLogin() {
              return G;
            },
            doLoginBasicLogin: function doLoginBasicLogin() {
              return F;
            },
            emitAccessToken: function emitAccessToken() {
              return j;
            },
            getAccessToken: function getAccessToken() {
              return q;
            },
            getAuthInfo: function getAuthInfo() {
              return J;
            },
            getAuthUrl: function getAuthUrl() {
              return v;
            },
            getIdToken: function getIdToken() {
              return X;
            },
            getLogoutUrl: function getLogoutUrl() {
              return M;
            },
            getOAuth2ClientId: function getOAuth2ClientId() {
              return z;
            },
            getOAuth2Flow: function getOAuth2Flow() {
              return Y;
            },
            getOAuth2IDPBaseUrl: function getOAuth2IDPBaseUrl() {
              return ee;
            },
            getOAuth2Scopes: function getOAuth2Scopes() {
              return oe;
            },
            initLogOut: function initLogOut() {
              return te;
            },
            isIdTokenAlive: function isIdTokenAlive() {
              return ae;
            },
            passwordlessLogin: function passwordlessLogin() {
              return ie;
            },
            passwordlessStart: function passwordlessStart() {
              return re;
            },
            refreshAccessToken: function refreshAccessToken() {
              return Q;
            },
            storeAuthInfo: function storeAuthInfo() {
              return V;
            },
            useOAuth2RefreshToken: function useOAuth2RefreshToken() {
              return Z;
            },
            validateIdToken: function validateIdToken() {
              return ne;
            }
          });
          var n = t(9558),
            r = t(5812),
            i = t.n(r),
            c = t(806),
            s = t.n(c);
          var l = require("browser-tabs-lock");
          var u = t.n(l);
          var _ = require("js-cookie");
          var d = t.n(_),
            R = t(8041),
            p = t.n(R),
            E = t(9891),
            f = t.n(E),
            S = t(5097);
          var w = require("crypto-js/sha256");
          var O = t.n(w);
          var h = require("crypto-js/enc-base64url");
          var g = t.n(h);
          var T = require("crypto-js/enc-hex");
          var A = t.n(T);
          var I = 65536,
            y = "undefined" != typeof window ? window.crypto || window.msCrypto : null;
          var k = t(3195);
          var U = s();
          var Lock = new (u())(),
            GET_TOKEN_SILENTLY_LOCK_KEY = "openstackuicore.lock.getTokenSilently",
            m = 60,
            N = "token id_token",
            P = "code",
            H = "authInfo",
            C = "nonce",
            L = "pkce",
            b = "idToken",
            v = function v() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
              var c = z(),
                s = (0, n.getAuthCallback)(),
                l = ee(),
                u = oe(),
                _ = Y();
              null != e && (s += "?BackUrl=".concat(encodeURI(e)));
              var d = x(16);
              (0, n.putOnLocalStorage)(C, d);
              var R = p()("".concat(l, "/oauth2/auth")),
                E = {
                  response_type: encodeURI(_),
                  scope: encodeURI(u),
                  nonce: d,
                  response_mode: "fragment",
                  client_id: encodeURI(c),
                  redirect_uri: encodeURI(s)
                };
              if (_ === P) {
                var _e = K();
                (0, n.putOnLocalStorage)(L, JSON.stringify(_e)), E.code_challenge = _e.codeChallenge, E.code_challenge_method = "S256", E.approval_prompt = "force";
              }
              return o && (E.prompt = o), u && u.includes("offline_access") && (E.prompt = "consent"), t && (E.id_token_hint = t), r && (E.provider = r), a && (E.otp_login_hint = a), i && (E.login_hint = encodeURI(i)), R = R.query(E), R;
            },
            M = function M() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var o = ee(),
                t = z(),
                r = p()("".concat(o, "/oauth2/end-session")),
                i = x(16),
                a = "".concat((0, n.getOrigin)(), "/auth/logout");
              (0, n.putOnLocalStorage)("post_logout_state", i);
              var c = {
                post_logout_redirect_uri: encodeURI(a),
                client_id: encodeURI(t),
                state: i
              };
              return e && (c.id_token_hint = e), r.query(c);
            },
            x = function x(e) {
              var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
                t = "";
              for (var _n = 0; _n < e; _n++) {
                t += o.charAt(Math.floor(62 * Math.random()));
              }
              return t;
            },
            G = function G() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              var a = v(e, t, null, o, r, i);
              (0, n.getCurrentLocation)().replace(a.toString());
            },
            F = function F() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              G(e, null, null, o, t);
            },
            K = function K() {
              var e = (0, n.base64URLEncode)(function (e) {
                if (e > 4294967295) throw new RangeError("requested too many random bytes");
                var o = Buffer.allocUnsafe(e);
                if (!y) return a;
                if (e > 0) if (e > I) for (var _t = 0; _t < e; _t += I) {
                  y.getRandomValues(o.slice(_t, _t + I));
                } else y.getRandomValues(o);
                return o;
              }(64));
              return {
                codeVerifier: e,
                codeChallenge: function (e) {
                  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hex";
                  var t = A();
                  return "Base64url" === o && (t = g()), O()(e).toString(t);
                }(e, "Base64url"),
                createdAt: new Date()
              };
            },
            j = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                var o,
                  t,
                  r,
                  i,
                  a,
                  c,
                  _e2,
                  _o,
                  _n2,
                  _r,
                  _i,
                  _a,
                  _s,
                  _l,
                  _args = arguments;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        o = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
                        t = ee(), r = z(), i = (0, n.getAuthCallback)(), a = JSON.parse((0, n.getFromLocalStorage)(L, !0));
                        if (a) {
                          _context.next = 4;
                          break;
                        }
                        throw Error(k.AUTH_ERROR_MISSING_PKCE_PARAM);
                      case 4:
                        null != o && (i += "?BackUrl=".concat(encodeURI(o)));
                        c = {
                          code: e,
                          grant_type: "authorization_code",
                          code_verifier: a.codeVerifier,
                          client_id: encodeURI(r),
                          redirect_uri: encodeURI(i)
                        };
                        _context.prev = 6;
                        _context.next = 9;
                        return fetch("".concat(t, "/oauth2/token"), {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify(c)
                        }).catch(function (e) {
                          console.log("Request failed:", e.message);
                        });
                      case 9:
                        _e2 = _context.sent;
                        _context.next = 12;
                        return _e2.json();
                      case 12:
                        _o = _context.sent;
                        _n2 = _o.access_token, _r = _o.refresh_token, _i = _o.id_token, _a = _o.expires_in, _s = _o.error, _l = _o.error_description;
                        return _context.abrupt("return", {
                          access_token: _n2,
                          refresh_token: _r,
                          id_token: _i,
                          expires_in: _a,
                          error: _s,
                          error_description: _l
                        });
                      case 17:
                        _context.prev = 17;
                        _context.t0 = _context["catch"](6);
                        console.log(_context.t0);
                      case 20:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[6, 17]]);
              }));
              return function j(_x) {
                return _ref.apply(this, arguments);
              };
            }(),
            D = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var e, o, t, n, r, a, c, s;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        console.log("openstack-uicore-foundation::Security::methods::_getAccessToken");
                        e = J();
                        if (e) {
                          _context3.next = 4;
                          break;
                        }
                        throw console.log("openstack-uicore-foundation::Security::methods::_getAccessToken AUTH_ERROR_MISSING_AUTH_INFO"), Error(k.AUTH_ERROR_MISSING_AUTH_INFO);
                      case 4:
                        o = e.accessToken, t = e.expiresIn, n = e.accessTokenUpdatedAt, r = e.refreshToken, a = Y();
                        c = i()().unix();
                        s = c - n;
                        t -= m;
                        console.log("openstack-uicore-foundation::Security::methods::_getAccessToken now ".concat(c, " accessTokenUpdatedAt ").concat(n, " expiresIn ").concat(t, " timeElapsedSecs ").concat(s));
                        _context3.t0 = s >= t || null == o;
                        if (!_context3.t0) {
                          _context3.next = 15;
                          break;
                        }
                        console.log("openstack-uicore-foundation::Security::methods::_getAccessToken  access token expired, refreshing it ...");
                        _context3.next = 14;
                        return function () {
                          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, o) {
                            var _e3, _t2, _n3, _r2, _i2;
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    if (!(e === P && Z())) {
                                      _context2.next = 11;
                                      break;
                                    }
                                    if (o) {
                                      _context2.next = 3;
                                      break;
                                    }
                                    throw W(), Error(k.AUTH_ERROR_MISSING_REFRESH_TOKEN);
                                  case 3:
                                    _context2.next = 5;
                                    return Q(o);
                                  case 5:
                                    _e3 = _context2.sent;
                                    _t2 = _e3.access_token;
                                    _n3 = _e3.expires_in;
                                    _r2 = _e3.refresh_token;
                                    _i2 = _e3.id_token;
                                    return _context2.abrupt("return", (void 0 === _r2 && (_r2 = null), V(_t2, _n3, _r2, _i2), _t2));
                                  case 11:
                                    throw W(), Error(k.AUTH_ERROR_ACCESS_TOKEN_EXPIRED);
                                  case 12:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));
                          return function (_x2, _x3) {
                            return _ref3.apply(this, arguments);
                          };
                        }()(a, r);
                      case 14:
                        o = _context3.sent;
                      case 15:
                        return _context3.abrupt("return", o);
                      case 16:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
              return function D() {
                return _ref2.apply(this, arguments);
              };
            }(),
            q = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var e;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!(null !== (e = navigator) && void 0 !== e && e.locks)) {
                          _context5.next = 4;
                          break;
                        }
                        _context5.next = 3;
                        return navigator.locks.request(GET_TOKEN_SILENTLY_LOCK_KEY, /*#__PURE__*/function () {
                          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
                            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    console.log("openstack-uicore-foundation::Security::methods::getAccessToken web lock api", e);
                                    _context4.next = 3;
                                    return D();
                                  case 3:
                                    return _context4.abrupt("return", _context4.sent);
                                  case 4:
                                  case "end":
                                    return _context4.stop();
                                }
                              }
                            }, _callee4);
                          }));
                          return function (_x4) {
                            return _ref5.apply(this, arguments);
                          };
                        }());
                      case 3:
                        return _context5.abrupt("return", _context5.sent);
                      case 4:
                        _context5.next = 6;
                        return (0, n.retryPromise)(function () {
                          return Lock.acquireLock(GET_TOKEN_SILENTLY_LOCK_KEY, 6e3);
                        }, 10);
                      case 6:
                        if (_context5.sent) {
                          _context5.next = 8;
                          break;
                        }
                        throw Error(k.AUTH_ERROR_LOCK_ACQUIRE_ERROR);
                      case 8:
                        _context5.prev = 8;
                        _context5.next = 11;
                        return D();
                      case 11:
                        return _context5.abrupt("return", _context5.sent);
                      case 12:
                        _context5.prev = 12;
                        _context5.next = 15;
                        return Lock.releaseLock(GET_TOKEN_SILENTLY_LOCK_KEY);
                      case 15:
                        return _context5.finish(12);
                      case 16:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[8,, 12, 16]]);
              }));
              return function q() {
                return _ref4.apply(this, arguments);
              };
            }(),
            $ = function $() {
              console.log("openstack-uicore-foundation::Security::methods::_clearAccessToken");
              var e = J();
              if (!e) throw console.log("openstack-uicore-foundation::Security::methods::_clearAccessToken AUTH_ERROR_MISSING_AUTH_INFO"), Error(k.AUTH_ERROR_MISSING_AUTH_INFO);
              var o = e.accessToken,
                t = e.expiresIn,
                n = e.accessTokenUpdatedAt,
                r = e.refreshToken;
              V(null, 0, r);
            },
            B = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                var e;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!(null !== (e = navigator) && void 0 !== e && e.locks)) {
                          _context7.next = 5;
                          break;
                        }
                        _context7.next = 3;
                        return navigator.locks.request(GET_TOKEN_SILENTLY_LOCK_KEY, /*#__PURE__*/function () {
                          var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
                            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                              while (1) {
                                switch (_context6.prev = _context6.next) {
                                  case 0:
                                    console.log("openstack-uicore-foundation::Security::methods::clearAccessToken web lock api", e), $();
                                  case 1:
                                  case "end":
                                    return _context6.stop();
                                }
                              }
                            }, _callee6);
                          }));
                          return function (_x5) {
                            return _ref7.apply(this, arguments);
                          };
                        }());
                      case 3:
                        _context7.next = 15;
                        break;
                      case 5:
                        _context7.next = 7;
                        return (0, n.retryPromise)(function () {
                          return Lock.acquireLock(GET_TOKEN_SILENTLY_LOCK_KEY, 6e3);
                        }, 10);
                      case 7:
                        if (_context7.sent) {
                          _context7.next = 9;
                          break;
                        }
                        throw Error(k.AUTH_ERROR_LOCK_ACQUIRE_ERROR);
                      case 9:
                        _context7.prev = 9;
                        $();
                      case 11:
                        _context7.prev = 11;
                        _context7.next = 14;
                        return Lock.releaseLock(GET_TOKEN_SILENTLY_LOCK_KEY);
                      case 14:
                        return _context7.finish(11);
                      case 15:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[9,, 11, 15]]);
              }));
              return function B() {
                return _ref6.apply(this, arguments);
              };
            }(),
            Q = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
                var o, t, r, _e4, _t3, _i3, _a2, _c, _s2;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        o = ee(), t = z();
                        r = {
                          grant_type: "refresh_token",
                          client_id: encodeURI(t),
                          refresh_token: e
                        };
                        _context8.prev = 2;
                        _context8.next = 5;
                        return fetch("".concat(o, "/oauth2/token"), {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify(r)
                        }).then(function (e) {
                          if (400 === e.status) {
                            (0, n.getCurrentPathName)();
                            throw (0, n.setSessionClearingState)(!0), Error("".concat(k.AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR, ": ").concat(e.status, " - ").concat(e.statusText));
                          }
                          return e;
                        }).catch(function (e) {
                          throw Error("".concat(k.AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR, ": ").concat(e.message));
                        });
                      case 5:
                        _e4 = _context8.sent;
                        _context8.next = 8;
                        return _e4.json();
                      case 8:
                        _t3 = _context8.sent;
                        _i3 = _t3.access_token, _a2 = _t3.refresh_token, _c = _t3.expires_in, _s2 = _t3.id_token;
                        return _context8.abrupt("return", {
                          access_token: _i3,
                          refresh_token: _a2,
                          expires_in: _c,
                          id_token: _s2
                        });
                      case 13:
                        _context8.prev = 13;
                        _context8.t0 = _context8["catch"](2);
                        throw console.log(_context8.t0), _context8.t0;
                      case 16:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8, null, [[2, 13]]);
              }));
              return function Q(_x6) {
                return _ref8.apply(this, arguments);
              };
            }(),
            V = function V(e, o) {
              var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var i = J(),
                a = {
                  accessToken: e,
                  expiresIn: o,
                  accessTokenUpdatedAt: Math.floor(Date.now() / 1e3)
                };
              null == t && i && (t = i.refreshToken), null == r && i && (r = i.idToken), t && (a.refreshToken = t), r ? (a[b] = r, d().set(b, r, {
                secure: !0,
                sameSite: "Lax"
              })) : d().remove(b), (0, n.putOnLocalStorage)(H, JSON.stringify(a));
            },
            J = function J() {
              try {
                var e = (0, n.getFromLocalStorage)(H, !1);
                return e ? JSON.parse(e) : null;
              } catch (e) {
                return null;
              }
            },
            W = function W() {
              "undefined" != typeof window && ((0, n.removeFromLocalStorage)(H), d().remove(b));
            },
            X = function X() {
              if ("undefined" != typeof window) {
                var e = J();
                return e ? e.idToken : null;
              }
              return null;
            },
            z = function z() {
              return "undefined" != typeof window ? window.OAUTH2_CLIENT_ID : null;
            },
            Y = function Y() {
              return "undefined" != typeof window && window.OAUTH2_FLOW || "token id_token";
            },
            Z = function Z() {
              return "undefined" == typeof window || new Boolean(window.OAUTH2_USE_REFRESH_TOKEN || !0);
            },
            ee = function ee() {
              return "undefined" != typeof window ? window.IDP_BASE_URL : null;
            },
            oe = function oe() {
              return "undefined" != typeof window ? window.SCOPES : null;
            },
            te = function te() {
              (0, n.getCurrentLocation)().replace(M(X()).toString());
            },
            ne = function ne(e, o, t) {
              var r = new (f())({
                  issuer: o,
                  audience: t
                }),
                i = (0, n.getFromLocalStorage)(C, !0);
              if (!i) throw Error(k.AUTH_ERROR_MISSING_NONCE_PARAM);
              var a = r.decode(e),
                c = (a.header.alg, a.header.kid, a.payload.aud),
                s = a.payload.iss;
              a.payload.exp, a.payload.nbf;
              return (a.payload.nonce || null) == i && c == t && s == o;
            },
            re = function re(e) {
              var o = z(),
                t = oe(),
                r = x(16);
              (0, n.putOnLocalStorage)(C, r);
              var i = ee(),
                a = p()("".concat(i, "/oauth2/auth")),
                c = {
                  response_type: "otp",
                  scope: encodeURI(t),
                  nonce: r,
                  client_id: encodeURI(o),
                  connection: e.connection || "email",
                  send: e.send || "code"
                };
              return e.hasOwnProperty("email") && (c.email = encodeURIComponent(e.email)), e.hasOwnProperty("phone_number") && (c.phone_number = encodeURIComponent(e.phone_number)), e.hasOwnProperty("redirect_uri") && (c.redirect_uri = encodeURIComponent(e.redirect_uri)), U.post(a.toString()).send(c).then(function (e) {
                var o = e.body;
                return Promise.resolve({
                  response: o
                });
              }).catch(function (e) {
                return Promise.reject(e);
              });
            },
            ie = function ie(e) {
              return function (o) {
                var t = z(),
                  n = oe(),
                  r = ee(),
                  i = p()("".concat(r, "/oauth2/token"));
                if (!e.hasOwnProperty("otp")) throw Error(k.AUTH_ERROR_MISSING_OTP_PARAM);
                var a = {
                  grant_type: "passwordless",
                  connection: e.connection || "email",
                  scope: encodeURI(n),
                  client_id: encodeURI(t),
                  otp: e.otp
                };
                return e.hasOwnProperty("email") && (a.email = encodeURIComponent(e.email)), e.hasOwnProperty("phone_number") && (a.phone_number = encodeURIComponent(e.phone_number)), U.post(i.toString()).send(a).then(function (e) {
                  try {
                    var _n4 = e.body,
                      _i4 = _n4.access_token,
                      _a3 = _n4.expires_in,
                      _c2 = _n4.refresh_token,
                      _s3 = _n4.id_token;
                    if (void 0 === _c2 && (_c2 = null), void 0 === _s3 && (_s3 = null), _s3 && !ne(_s3, r, t)) throw Error(k.AUTH_ERROR_ID_TOKEN_INVALID);
                    return V(_i4, _a3, _c2, _s3), o && o({
                      type: S.SET_LOGGED_USER,
                      payload: {
                        sessionState: null
                      }
                    }), Promise.resolve({
                      response: _n4
                    });
                  } catch (e) {
                    return console.log(e), Promise.reject(e);
                  }
                }).catch(function (e) {
                  return Promise.reject(e);
                });
              };
            },
            ae = function ae() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              return function () {
                e || (e = Math.floor(Date.now() / 1e3));
                var o = X();
                if (!o) throw Error("Id Token not set.");
                var t = ee(),
                  n = z();
                return new (f())({
                  issuer: t,
                  audience: n
                }).decode(o).payload.exp - (e + m) > 0;
              };
            };
        },
        9087: function _(e, o, t) {
          t(2462), t(806), t(8041), t(9236), t(6842), t(9558), t(5097), t(1742);
          var n = function n(e) {
            return function (o) {
              return {
                type: e,
                payload: o
              };
            };
          };
          n("RESET_LOADING"), n("START_LOADING"), n("STOP_LOADING");
        },
        9558: function _(e, o, t) {
          t.d(o, {
            base64URLEncode: function base64URLEncode() {
              return _;
            },
            getAuthCallback: function getAuthCallback() {
              return n;
            },
            getCurrentLocation: function getCurrentLocation() {
              return r;
            },
            getCurrentPathName: function getCurrentPathName() {
              return a;
            },
            getFromLocalStorage: function getFromLocalStorage() {
              return s;
            },
            getOrigin: function getOrigin() {
              return i;
            },
            putOnLocalStorage: function putOnLocalStorage() {
              return c;
            },
            removeFromLocalStorage: function removeFromLocalStorage() {
              return l;
            },
            retryPromise: function retryPromise() {
              return d;
            },
            setSessionClearingState: function setSessionClearingState() {
              return u;
            }
          });
          t(5812), t(8041);
          var n = function n() {
              return "undefined" != typeof window ? "".concat(window.location.origin, "/auth/callback") : null;
            },
            r = function r() {
              var e = "";
              return "undefined" != typeof window && (e = window.location, window.top && (e = window.top.location)), e;
            },
            i = function i() {
              return "undefined" != typeof window ? window.location.origin : null;
            },
            a = function a() {
              return "undefined" != typeof window ? window.location.pathname : null;
            },
            c = function c(e, o) {
              "undefined" != typeof window && window.localStorage.setItem(e, o);
            },
            s = function s(e, o) {
              if ("undefined" != typeof window) {
                var _t4 = window.localStorage.getItem(e);
                return o && (console.log("getFromLocalStorage removing key ".concat(e)), l(e)), _t4;
              }
              return null;
            },
            l = function l(e) {
              "undefined" != typeof window && window.localStorage.removeItem(e);
            },
            u = function u(e) {
              "undefined" != typeof window && (window.clearing_session_state = e);
            },
            _ = function _(e) {
              return e.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
            },
            d = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
                var o,
                  _t5,
                  _args9 = arguments;
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        o = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : 3;
                        _t5 = 0;
                      case 2:
                        if (!(_t5 < o)) {
                          _context9.next = 10;
                          break;
                        }
                        _context9.next = 5;
                        return e();
                      case 5:
                        if (!_context9.sent) {
                          _context9.next = 7;
                          break;
                        }
                        return _context9.abrupt("return", !0);
                      case 7:
                        _t5++;
                        _context9.next = 2;
                        break;
                      case 10:
                        return _context9.abrupt("return", !1);
                      case 11:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));
              return function d(_x7) {
                return _ref9.apply(this, arguments);
              };
            }();
        },
        1116: function _(e) {
          e.exports = require("@babel/runtime/helpers/defineProperty");
        },
        2462: function _(e) {
          e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
        },
        6842: function _(e) {
          e.exports = require("i18n-react/dist/i18n-react");
        },
        9891: function _(e) {
          e.exports = require("idtoken-verifier");
        },
        5812: function _(e) {
          e.exports = require("moment-timezone");
        },
        806: function _(e) {
          e.exports = require("superagent/lib/client");
        },
        9236: function _(e) {
          e.exports = require("sweetalert2");
        },
        8041: function _(e) {
          e.exports = require("urijs");
        }
      },
      o = {};
    function t(n) {
      var r = o[n];
      if (void 0 !== r) return r.exports;
      var i = o[n] = {
        exports: {}
      };
      return e[n](i, i.exports, t), i.exports;
    }
    return function () {
      t.n = function (e) {
        var o = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(o, {
          a: o
        }), o;
      };
    }(), function () {
      t.d = function (e, o) {
        for (var n in o) {
          t.o(o, n) && !t.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: o[n]
          });
        }
      };
    }(), function () {
      t.o = function (e, o) {
        return Object.prototype.hasOwnProperty.call(e, o);
      };
    }(), function () {
      t.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
    }(), t(1742);
  }();
});